export const DEFAULT_PAGE_SIZE = 25;
export const ALLOWED_PAGE_SIZES = [10, 25, 50, 100];
export const ALLOWED_ORDERING = [
  'registration_num',
  'asset_code',
  'site_name',
  'group_name',
  'type',
  'active',
  'tyre_management_enabled',
];

const BOOLEAN_PARAMS = ['active', 'tyre_management_enabled'];

const parseBoolean = (value) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
};

const parsePositiveInt = (value, fallback) => {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 1) return fallback;
  return parsed;
};

export const parseVehicleListQuery = (search) => {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  const orderingRaw = params.get('ordering') || '';
  const orderingField = orderingRaw.replace(/^-/, '');
  const ordering = ALLOWED_ORDERING.includes(orderingField) ? orderingRaw : '';
  const pageSize = parsePositiveInt(params.get('page_size'), DEFAULT_PAGE_SIZE);

  return {
    search: (params.get('search') || '').trim(),
    site: params.get('site') || '',
    group: params.get('group') || '',
    active: parseBoolean(params.get('active')),
    tyre_management_enabled: parseBoolean(params.get('tyre_management_enabled')),
    ordering,
    page: parsePositiveInt(params.get('page'), 1),
    page_size: ALLOWED_PAGE_SIZES.includes(pageSize) ? pageSize : DEFAULT_PAGE_SIZE,
  };
};

export const serializeVehicleListQuery = (query) => {
  const params = new URLSearchParams();
  const search = (query.search || '').trim();
  if (search) params.set('search', search);
  if (query.site) params.set('site', String(query.site));
  if (query.group) params.set('group', String(query.group));
  BOOLEAN_PARAMS.forEach((key) => {
    if (query[key] === true || query[key] === false) params.set(key, String(query[key]));
  });
  if (query.ordering) params.set('ordering', query.ordering);
  if (query.page && query.page !== 1) params.set('page', String(query.page));
  if (query.page_size && query.page_size !== DEFAULT_PAGE_SIZE) {
    params.set('page_size', String(query.page_size));
  }
  return params.toString();
};

export const toRequestParams = (query) => {
  const params = {
    search: query.search || undefined,
    site: query.site || undefined,
    group: query.group || undefined,
    ordering: query.ordering || undefined,
    page: query.page,
    page_size: query.page_size,
  };
  BOOLEAN_PARAMS.forEach((key) => {
    if (query[key] === true || query[key] === false) params[key] = query[key];
  });
  return params;
};

export const countAppliedFilters = (query) => [
  query.site,
  query.group,
  query.active === true || query.active === false,
  query.tyre_management_enabled === true || query.tyre_management_enabled === false,
].filter(Boolean).length;

export const hasActiveConstraints = (query) => (
  Boolean((query.search || '').trim()) || countAppliedFilters(query) > 0
);
